import React, { useState, useEffect } from 'react';
import './UpdateUserForm.css';
import { Text, SelectField } from '@aws-amplify/ui-react';
import { updateUser } from '../graphql/mutations';
import { generateClient } from 'aws-amplify/api';
import { updateCognitoUser } from '../api/adminUsersApi';

const client = generateClient();
const ROLE_GROUPS = {
  "Administrador": "Administradores",
  "Operador": "Operadores",
  "Cliente": "Clientes"
};

const UpdateUserForm = ({ selectUser, onCancel, onUpdate }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  // const [isAdmin, setIsAdmin] = useState(false);
  const [role, setRole] = useState('Cliente');
  const [error, setError] = useState('');
  // const [updatedUser, setUpdatedUser] = useState({});

  useEffect(() => {
    setUsername(selectUser.username);
    setEmail(selectUser.email);
    setRole(selectUser.role);
    // setIsAdmin(selectUser.isAdmin);
  }, []);

  const handlersOnCancel = () => {
    onCancel();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    // Handle form submission logic
    if (username === selectUser.username && email === selectUser.email && role === selectUser.role) {
      setError('No hay datos para actualizar');
      return;
    }
    try {
      const newGroupName = ROLE_GROUPS[role];
      const previousGroupName = ROLE_GROUPS[selectUser.role];

      console.log("Updating user in Cognito...");
      await updateCognitoUser({
        username,
        email,
        role: newGroupName,
        previousRole: previousGroupName,
        ...(selectUser.name ? { name: selectUser.name } : {})
      });
      console.log("User attributes updated successfully in Cognito");

      const updatedUser = await client.graphql({
        query: updateUser,
        variables: {
          input: {
            id: selectUser.id,
            username: username,
            email: email,
            isAdmin: role === 'Administrador' ? true : false,
            role: role
          }
        }
      })
      onUpdate(updatedUser.data.updateUser);

      console.log("user updated successfully");
      return;
    } catch (error) {
      console.error("Error updating user:", error);
      setError(error?.message || 'No se pudo actualizar el usuario.');
      return;
    }
  };

  return (
    <>
      <Text color="#588292">ACTUALIZAR USUARIO</Text>
      <br />
      <form onSubmit={handleSubmit}>
        <label>
          Username*
          <input
            type="text"
            value={username}
            disabled="disabled"
          />
        </label>
        <label>
          Email*
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled="disabled"
          />
        </label>
        {/* <label className="isAdmin-label">
          isAdmin
                    <SwitchField
            isChecked={isAdmin}
            labelPosition="start"
            onChange={(e) => setIsAdmin(e.target.checked)}
            />
        </label>    */}
        <label className="isAdmin-label">
          <SelectField
            label="Role"
            options={['Administrador', 'Operador', 'Cliente']}
            value={role}
            onChange={(e) => setRole(e.target.value)}
          ></SelectField>
        </label>

        {error && <Text color="red">{error}</Text>}
        <div className="button-container">
          <button type="button" onClick={handlersOnCancel}>
            Cancelar
          </button>
          <button type="submit">
            Actualizar
          </button>
        </div>
      </form>
    </>
  );
};

export default UpdateUserForm;
